import { useAuthStore } from '@/shared/lib/store';
import { isPartnerUser } from './userType';

/** True when the logged-in user from `/auth/user-me` is a Partner. */
export const useIsPartnerUser = (): boolean => {
  const userType = useAuthStore((state) => state.user?.user_type);
  return isPartnerUser(userType);
};
